export default "__VITE_ASSET__DSxYOIj1__"